export const PATHS = {
    WELCOME: '/welcome',
    LAUNCH: '/launch',
    FEATURES: '/features',
    LOGIN: '/login',
    TWITTER_CALLBACK: '/twitter/callback',
    LOGIN_INTERNAL: '/login/internal',
    SIGN_UP: '/signup',
    SIGN_UP_INTERNAL: '/signup/internal',
    HOME: '/',
    VIEW_POST: '/posts/:id',
    WRITE_POST: '/write-post',
    PROFILE: '/profile',
    HISTORY: '/profile/history',
    REPUTATION: '/profile/reputation',
    ABOUT_US: '/about',
    NOTIFICATION: '/notification',
    REPORT_DETAIL: '/reports/:id',
}
